import AbstractComponent from './AbstractComponent';
import { OPENED, ENTER, LEAVE } from 'core/Classes';
import { MODAL_TOGGLE, SCROLL_TOGGLE } from 'core/Events';
import EmitterManager from '../managers/EmitterManager';
import { createCookie, deleteCookie, readCookie } from 'helpers/Cookies';

class Modal extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleClickToggle = this.handleClickToggle.bind(this);
    this.handleClickClose = this.handleClickClose.bind(this);
    this.handleClickHash = this.handleClickHash.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$autoOpen = document.querySelector('[data-modal-auto-open]');
    ui.$toggles = [...document.querySelectorAll('[data-modal-toggle]')];
    ui.$content = ui.$element.querySelector('.modal__content');
    return ui;
  }

  initializeBeforeEvents() {
    this.hasCookie = !!this.ui.$element.dataset.expires;
  }

  initialize() {
    this.id = this.$element.id;

    if (this.ui.$autoOpen) {
      const id = this.ui.$autoOpen.dataset.modalAutoOpen;
      this.open(this.getModalElFromId(id));
    }
  }

  destroy() {
    this.events(false);
    this.eventsModal(this.ui.$element, false);
    this.ui.$element.remove();
  }

  events(listen) {
    const { hash } = this.$element.dataset;
    const listener = listen ? 'on' : 'removeListener';
    const eventListener = listen ? 'addEventListener' : 'removeEventListener';
    const $listener = listen ? 'on' : 'off';

    this.ui.$toggles.forEach(($toggle) => $toggle[eventListener]('click', this.handleClickToggle));

    EmitterManager[listener](MODAL_TOGGLE, this.handleModalToggle);

    if (hash) {
      $(document.body)[$listener]('click', `a[href="#${hash}"]`, this.handleClickHash);
    }
  }

  eventsModal($modal, listen) {
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    [...$modal.querySelectorAll('.modal__overlay, .modal__close, [data-modal-close]')]
      .filter(($item) => $item !== null)
      .forEach(($item) => $item[listener]('click', this.handleClickClose));
  }

  handleModalToggle(id) {
    if (id !== this.ui.$element.id) return;
    const $modal = document.querySelector(`#${id}`);
    this.open($modal);
  }

  handleClickHash(event) {
    event.preventDefault();
    this.open();
  }

  handleClickClose(event) {
    event.preventDefault();
    const $modal = event.currentTarget.closest('.modal');
    this.close($modal);
  }

  handleClickToggle(event) {
    event.preventDefault();

    const $element = event.currentTarget;
    const $modal = this.getModalElFromId($element.dataset.modalToggle);
    console.log($element.dataset.modalToggle, $modal);
    if ($modal) {
      this.open($modal, true);
    }
  }

  getModalElFromId(id) {
    return document.querySelector(`#${id}`);
  }

  open($modal = this.$element, forceOpen = false) {
    if (!$modal) return;

    if (forceOpen === false && this.hasCookie) {
      const cookie = readCookie(`modal-${$modal.id}`);
      const force = !!$modal.querySelector('[data-modal-auto-open]');

      if (!force && (cookie !== null || cookie === 'yes')) {
        return false;
      } else {
        deleteCookie(`modal-${$modal.id}`);
      }
    }

    EmitterManager.emit(SCROLL_TOGGLE, true);

    $modal.classList.add(OPENED);
    $modal.classList.remove(LEAVE);

    requestIdleCallback(() => {
      $modal.classList.add(ENTER);

      this.eventsModal($modal, true);
    });
  }

  close($modal) {
    this.eventsModal($modal, false);

    if (this.hasCookie) {
      createCookie(`modal-${$modal.id}`, 'yes', $modal.dataset.expires || 7, '/');
    }

    EmitterManager.emit(SCROLL_TOGGLE, false);

    $modal.classList.add(LEAVE);
    $modal.classList.remove(ENTER);

    setTimeout(() => {
      $modal.classList.remove(OPENED);
    }, 550);
  }
}

export default Modal;
